import React, { Component } from "react";
import TimeBlock from './time_block';
import Flexbox from 'flexbox-react';
import {observer, inject} from 'mobx-react';

const liveOrderStreamHeaderTime = {
    "fontSize": "1.7em",
    "fontFamily": 'GraphikLight',
    "letterSpacing": "-0.3px"
};

function generateTimeBlockComponentsArray(timeBlockArray, shrinked) {
    return timeBlockArray.map((timeBlock, index)=>{
        return <TimeBlock key={index} block={timeBlock} shrinked={shrinked}/>;
    });
}
function calculateFontSize(isVertical){
    if(isVertical) {
        return '1vh'
    }
    return '2vh'
}

@inject('RootStore')
@observer
export default class LiveOrderStreamWidgetShopClosed extends Component {

    render() {
      const {styleStore, configStore, orderStore} = this.props.RootStore
      const textColor = styleStore.currentStylesDict.orderStreamWidgetFontColor;
      const {shrinked} = this.props;
      let shopHoursList = generateTimeBlockComponentsArray(orderStore.getCurrShopTimeBlocksArray, shrinked);
      const liveOrderStreamWidgetStyle = {
            'color': textColor || 'rgb(255, 234, 162)',
            'fontSize': calculateFontSize(configStore.isVertical)
        };
      const shopHoursHeader = {
          'fontFamily': 'GraphikMedium',
          'color': textColor,
          'fontSize': shrinked ? '2em' : '2.7em',
          'letterSpacing': '1.5%',
        };

      const shopHoursListStyle = {
        flexFlow:"column wrap",
        alignItems: "center",
        justifyContent:"center",
        textAlign: "center"
      }

        const mainHeader = {
          "fontFamily": "GraphikMedium",
          "fontSize": shrinked ? "2em" : "3.9em",
          "letterSpacing": "1.5%",
          "color": styleStore.currentStylesDict.shopCurrentlyClosedText
        };

        return (
            <Flexbox height="100%" width="100%" flexGrow={1} flexDirection="column" style={liveOrderStreamWidgetStyle}>
                <Flexbox flexGrow={.1} height="6%">
                </Flexbox>
                <Flexbox justifyContent="center" style={{...liveOrderStreamHeaderTime, "height": styleStore.currentLiveStreamOrderStyle.shopClosedTimeHeight}}>
                  {!shrinked && configStore.currentDateTime}
                </Flexbox>
                <Flexbox justifyContent="center" style={{...mainHeader, "height": styleStore.currentLiveStreamOrderStyle.shopClosedHeaderHeight}}>
                    We're currently closed!
                </Flexbox>
              {shopHoursList.length > 0 &&
                <React.Fragment>
                  <Flexbox justifyContent="center" height="6%" style={{...shopHoursHeader, "paddingBottom": styleStore.currentLiveStreamOrderStyle.shopClosedHoursPaddingBottom}}>
                    Shop Hours:
                  </Flexbox>
                  <Flexbox style={shopHoursListStyle}>
                    {shopHoursList}
                  </Flexbox>
                </React.Fragment>}
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/live_order_stream_panel/live_order_stream_widget_shop_closed.jsx